module.exports = __webpack_public_path__ + "02935c093c2dafc56f9985af218a81d2.jpg";